export class RfpCancellationStatusCodes {
  public static readonly Invalid = 'Invalid';
  public static readonly Received = 'Received';
  public static readonly Accepted = 'Accepted';
  public static readonly Denied = 'Denied';
}
